export const getPlayerWP = () => {
  const videoPlayer = document.getElementById(
    "watchpartyvideoplayer"
  ) as HTMLVideoElement
  return videoPlayer
}
